import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from 'react';
import ModalContentBase from '../modal/hooks/modal_content_base';
import ActionModal from './action_modal';

const youtubePrefix01 = 'https://www.youtube.com/watch?v=';
const youtubePrefix02 = 'https://youtu.be/';

const SectionVideo = ({
  index,
  content,
  userAgent,
  updateContent,
  isSelected,
  setSelectedIndex,
  deleteContent,
  hideNextButtonFunc,
  displayNextButtonFunc,
  onReorder,
  isBlogEditor,
}) => {
  const [bodyWithPrefix, setBodyWithPrefix] = useState('');
  const [isValidUrl, setIsValidUrl] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {
    const element = textareaRef.current;

    if (isSelected && element) {
      element.focus();
      element.setSelectionRange(element.value.length, element.value.length);
      element.scrollTop = element.scrollHeight;
    }
  }, [isSelected]);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const onChange = async (e) => {
    const value = e.target.value;

    let body = '';

    // prefixを除去
    if (!value.indexOf(youtubePrefix01)) {
      body = value.replace(youtubePrefix01, '');
    } else if (!value.trim().indexOf(youtubePrefix02)) {
      body = value.replace(youtubePrefix02, '');
    }

    // 末尾の空白・スラッシュ削除
    body = body.trim().replace(/\/$/, '');
    if (body.length > 0) {
      updateContent({ ...content, body: body });
    }

    setBodyWithPrefix(value);

    if (e.target.value) {
      hideNextButtonFunc && hideNextButtonFunc();
    } else {
      displayNextButtonFunc && displayNextButtonFunc();
    }
  };

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === 'Backspace' && bodyWithPrefix === '') {
        e.preventDefault();
      }
    },
    [bodyWithPrefix]
  );

  useEffect(() => {
    setIsValidUrl(
      bodyWithPrefix === '' ||
        bodyWithPrefix.includes(youtubePrefix01) ||
        bodyWithPrefix.includes(youtubePrefix02)
    );
  }, [bodyWithPrefix]);

  return (
    <Fragment>
      {isSelected || !isValidUrl ? (
        <div className="d-flex mt-2" style={{ minWidth: '75%' }}>
          <div className="mt-2 pt-1" style={{ width: '90%' }}>
            {isValidUrl ? (
              <p className="text-danger text-fz-small mt-2_5"></p>
            ) : (
              <p className="text-danger text-fz-small mb-0">
                書式が正しくありません（例：{`${youtubePrefix01}ABCdEf`})
              </p>
            )}
            <div className="m-0 d-flex">
              <textarea
                id="body"
                ref={textareaRef}
                className="textarea-no-border bg-white mt-0"
                style={{ fontSize: '16px' }}
                value={bodyWithPrefix}
                onChange={onChange}
                // onKeyDown={(e) => onKeyDown(e)}
                onFocus={() => setSelectedIndex(index)}
                placeholder={`${youtubePrefix01}ABCdEf`}
              />
            </div>
          </div>
          {userAgent === 'pc' ? (
            <div className="d-flex justify-content-center align-items-center">
              <button
                className="btn btn-primary--grad ml-2 text-fw-bold text-white"
                onClick={() => {
                  if (bodyWithPrefix === '') setIsValidUrl(false);
                  if (!isValidUrl) return;
                  setSelectedIndex((prev) => (prev == index ? null : prev));
                }}
                style={{ width: '75px' }}
              >
                適用
              </button>
              <button
                className="btn btn-primary--grad ml-2 text-fw-bold text-white"
                onClick={() => {
                  setSelectedIndex((prev) => (prev == index ? null : prev));
                  deleteContent();
                }}
                style={{ width: '75px' }}
              >
                削除
              </button>
            </div>
          ) : (
            <div className="d-flex align-items-center">
              <button
                className="btn btn-primary--grad ml-2 text-fw-bold text-white"
                style={{ width: '20vw', maxWidth: '75px' }}
                onClick={() => {
                  if (!isValidUrl || bodyWithPrefix === '') return;
                  setSelectedIndex((prev) => (prev == index ? null : prev));
                }}
              >
                適用
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="max-w-100 cursor-pointer">
          <div
            className="w-100 h-100 position-absolute"
            onClick={() => setIsModalOpen(true)}
            style={{ zIndex: 100 }}
          />
          {/* ブログ作成だけ: 動画の「編集」ボタン（押すと編集・削除の小窓） */}
          {isBlogEditor && (
            <button
              type="button"
              className="be-media-edit"
              aria-label="編集"
              onClick={() => setIsModalOpen(true)}
            />
          )}
          <div className="video">
            <iframe
              src={`https://www.youtube.com/embed/${content.body}`}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
      {isModalOpen && (
        <ModalContentBase
          closeModal={() => closeModal()}
          modalContent={
            <ActionModal
              closeModal={closeModal}
              onReorder={
                onReorder &&
                (() => {
                  closeModal();
                  onReorder();
                })
              }
              deleteContent={() => {
                closeModal();
                deleteContent();
              }}
              onEdit={() => {
                closeModal();
                setSelectedIndex(index);
                setBodyWithPrefix(`${youtubePrefix02}${content.body}`);
              }}
            />
          }
        />
      )}
      <div className="flex-grow-1" onClick={() => setIsModalOpen(true)} />
    </Fragment>
  );
};

export default SectionVideo;
